import { TrackingEventType } from "logger/event-utils";
import { sendToParent } from "logger/logger";

/**
 * Sends a message to close the modal if the application is running in a modal.
 * This is the SDK modal, not the casper modals.
 */
export function closeBookingModal() {
    if (window.parent !== window) {
        // Some customers will use this event to know that the modal is closed
        sendToParent({}, TrackingEventType.closeModal);
    }
}
